/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Clear_Descriptions_MenuInputs */



/**
* | output |
* | --- |
* | "Clear Marker Descriptions" |
*
* @param {Markers_Clear_Descriptions_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_clear_descriptions_menu = /** @type {((inputs?: Markers_Clear_Descriptions_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Clear_Descriptions_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacer les descriptions de marqueurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Beschreibungen der Markierungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizioni chiare dei marcatori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Описать маркеры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripciones claras de marcadores")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("清晰的标记描述")
	if (locale === "ja") return /** @type {LocalizedString} */ ("明確なマーカーの説明")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्कर विवरण स्पष्ट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrições claras dos marcadores")
	return /** @type {LocalizedString} */ ("Clear Marker Descriptions")
});